import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';

type DialogDeletePropsType = {
  title: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => void;
  onClose?: () => void;
};
export const DialogDelete = ({ title, open, setOpen, onConfirm, onClose }: DialogDeletePropsType) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Подтвердите удаление</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{title}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Отмена</Button>
        <Button
          color="error"
          onClick={handleConfirm}
          autoFocus
        >
          Да, удалить
        </Button>
      </DialogActions>
    </Dialog>
  );
};
